import { render, staticRenderFns } from "./PraticasPendentes.vue?vue&type=template&id=bfdf7d64"
import script from "./PraticasPendentes.vue?vue&type=script&lang=js"
export * from "./PraticasPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports